import { jsx as _jsx } from "react/jsx-runtime";
import { Trophy } from "mdi-material-ui";
export const RegLogo = () => _jsx(Trophy, {});
//# sourceMappingURL=RegLogo.js.map